<article *ngIf="isVisibleUnitSetting" class="popup popup-setting unit-setting">
    <div class="popup-wrap">
        <div class="tit-box">
            <div class="tit-txt">
                {{ "configuration.unitSetting" | translate }}
            </div>
            <a (click)="toggleUnitSettingVisible()" class="close-btn"></a>
        </div>
        <div class="con-box">
            <div *ngFor="let unitListItemDto of unitListDto.types; let i = index;" class="row">
                <div class="subject">
                    {{ getTypeCodeName(i) }}
                </div>
                <div class="con">
                    <div *ngFor="let unit of unitListItemDto.unitList; let j = index" class="rbox">
                        <label>
                            <input (click)="changeUnit($event)" type="radio" [name]="i" [value]="j" [checked]="(i == 0 && userUnit.windSpeedUnit == j) || (i == 1 && userUnit.temperatureUnit == j) || (i == 2 && userUnit.distanceUnit == j)">
                            <i></i>
                            <span class="txt">
                                {{ unit }}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</article>
